import { fetchApi } from './client';

export interface CustomChecklistItem {
  id: string;
  category: string;
  title: string;
  description?: string;
  order: number;
  isEnabled: boolean;
}

export interface ChecklistSettings {
  disabledDefaultItems: string[];
  customItems: CustomChecklistItem[];
}

export interface ClientSettings {
  id: string;
  bookkeepingId: string;
  clientId: string;
  clientName: string;
  quarterlyChecklistSettings: ChecklistSettings;
  yearEndChecklistSettings: ChecklistSettings;
  createdAt: string;
  updatedAt: string;
}

export interface DefaultChecklistItem {
  id: string;
  category: string;
  title: string;
  description?: string;
  order: number;
}

export const clientSettingsApi = {
  getSettings: async (bookkeepingId: string): Promise<ClientSettings> => {
    return fetchApi<ClientSettings>(`/clients/${bookkeepingId}/settings`);
  },

  updateSettings: async (bookkeepingId: string, data: {
    quarterlyChecklistSettings?: ChecklistSettings;
    yearEndChecklistSettings?: ChecklistSettings;
  }): Promise<ClientSettings> => {
    return fetchApi<ClientSettings>(`/clients/${bookkeepingId}/settings`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  toggleDefaultItem: async (bookkeepingId: string, data: {
    reviewType: 'quarterly' | 'year-end';
    itemTitle: string;
    isEnabled: boolean;
  }): Promise<ClientSettings> => {
    return fetchApi<ClientSettings>(`/clients/${bookkeepingId}/settings/toggle-item`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  addCustomItem: async (bookkeepingId: string, data: {
    reviewType: 'quarterly' | 'year-end';
    category: string;
    title: string;
    description?: string;
  }): Promise<ClientSettings> => {
    return fetchApi<ClientSettings>(`/clients/${bookkeepingId}/settings/custom-item`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  deleteCustomItem: async (bookkeepingId: string, itemId: string, reviewType: 'quarterly' | 'year-end'): Promise<ClientSettings> => {
    return fetchApi<ClientSettings>(`/clients/${bookkeepingId}/settings/custom-item/${itemId}?reviewType=${reviewType}`, {
      method: 'DELETE',
    });
  },

  getDefaultChecklistItems: async (reviewType: 'quarterly' | 'year-end'): Promise<DefaultChecklistItem[]> => {
    return fetchApi<DefaultChecklistItem[]>(`/checklist-templates/${reviewType}`);
  },
};
